import { convertSpecialSymbols, onDisplay, titleList } from '@/common/resources/directives'
import {
  EVENT_TYPE,
  MENU, ON_CLICK_CELL,
  SET_CURRENT_MENU,
  TOAST_TEXT,
  UPDATE_MAIN_LAYOUT_CONTENT
} from '@/common/resources/const'
import _ from 'lodash'
import { getCellEventObject, getSectionEventByType } from '@/common/utils/gnb.fp'
import {
  categoryInfo,
  EVENT_CLOSE_CATEGORY_LAYOUT,
  EVENT_CLOSE_GNB_CATEGORY_MENU
} from '@/common/utils/gnb.category'
import { fetchFromEventObject } from '@/common/utils/request.common'
import { mapMutations } from 'vuex'
import { parseUrl, stringify } from 'query-string'
import fp from 'lodash/fp'
import { removeProtocolAndWavveDomain } from '@/common/utils/common'
import { PATH_NAME_LIVE } from '@/common/resources/router.const'
import { sendEventLogExitToGnb } from '@/common/utils/log.v2.send'
import { LOG_SEND_LIST } from '@/common/resources/log.v2.const'

export default {
  props: {
   sectionInfo: {
     type: Object
   }
  },
  directives: {
    onDisplay,
    titleList
  },
  data () {
    return {
      title: '',
      cellList: []
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU]),
    fetchMenuBand () {
      this.title = convertSpecialSymbols(_.get(this.sectionInfo, 'title', ''))
      const onContent = getSectionEventByType(EVENT_TYPE.ON_CONTENT)(this.sectionInfo)
      const url = _.get(onContent, 'url', '')
      const hasCached = categoryInfo.hasCachedBandResponseByUrl(url)
      const onContentRequest = !hasCached ? () => fetchFromEventObject(onContent).then((response) => {
          categoryInfo.setSectionResponseMap(url, response)
          return response
        })
        : () => new Promise((resolve) => {
          resolve(_.get(categoryInfo, ['sectionResponseMap', url], null))
        })
      onContentRequest().then(({ data }) => {
        this.cellList = _.get(data, 'band.celllist', [])
      })
    },
    updateCurrentPage () {
      this.$events.$emit(EVENT_CLOSE_CATEGORY_LAYOUT)
      this.$events.$emit(UPDATE_MAIN_LAYOUT_CONTENT)
    },
    goCategoryProc (menuItem) {
      const { onClick, onNavigation } = fp.flow(fp.get('event_list'), getCellEventObject)(menuItem)
      this.$events.$emit(ON_CLICK_CELL, onClick)
      const { url, query } = parseUrl(_.get(onNavigation, 'url', ''))
      const isAdultOnly = _.get(onNavigation, 'adult', 'n').toUpperCase() === 'Y'
      if (isAdultOnly) {
        _.set(query, 'adult', 'y')
      }
      const hasQuery = Object.keys(query).length > 0
      if (hasQuery && _.get(query, 'api', '') !== '') query.api = encodeURIComponent(_.get(query, 'api', ''))
      const path = removeProtocolAndWavveDomain(hasQuery ? `${url}?${stringify(query)}` : url)
      if (LOG_SEND_LIST.includes(this.$route.name)) sendEventLogExitToGnb({ name: MENU.CATEGORY, route: this.$route, landingUrl: path })
      this[SET_CURRENT_MENU](MENU.CATEGORY)
      if (removeProtocolAndWavveDomain(url) === `/${PATH_NAME_LIVE}`) {
        const { query: currentQuery } = parseUrl(location.href)
        const currentGenre = _.get(currentQuery, 'genre', '')
        const nextGenre = _.get(query, 'genre', '')
        if (currentGenre === nextGenre) {
          this.updateCurrentPage()
        } else {
          this.$router.push(path).catch(() => { })
        }
      } else if (location.pathname === removeProtocolAndWavveDomain(url)) {
        this.updateCurrentPage()
      } else {
        this.$router.push(path).catch(() => { })
      }
    },
    goCategory (menuItem) {
      const { onNavigation } = fp.flow(fp.get('event_list'), getCellEventObject)(menuItem)
      const toastText = _.get(onNavigation, TOAST_TEXT, '')
      this.$events.$emit(EVENT_CLOSE_GNB_CATEGORY_MENU)
      this.$events.$emit(EVENT_CLOSE_CATEGORY_LAYOUT)
      if (toastText !== '') {
         this.$events.$emit('OPEN_PPV_TOAST', () => this.goCategoryProc(menuItem), toastText)
      } else {
        this.goCategoryProc(menuItem)
      }
    },
    getCategoryMenuTitleList (menuItem) {
      return [_.get(menuItem, 'title_list.0', {})]
    },
    hasHighlight (menuItem) {
      return _.get(menuItem, 'top_taglist', []).indexOf('highlight') > -1
    }
  },
  created () {
    this.fetchMenuBand()
  }
}
